<template>
  <div
    class="relative grid grid-cols-1 items-center gap-4 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5"
    :class="[$attrs.class]"
    data-testid="service-container-card"
  >
    <div
      v-for="service in services"
      :key="service.id"
      data-testid="service-card-item"
      class="[&_.icon-container]:odd:bg-p-400 [&_.icon-container]:even:bg-p-50"
      :class="!colorizeCards ? '[&_.icon-container]:!bg-s-200' : ''"
    >
      <ServicesCard
        :data-testid="`service-card-${service.slug}`"
        :service="service"
        :class="cardClasses"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import ServicesCard from '~/components/shared/services/Card.vue'

withDefaults(
  defineProps<{
    services: any[]
    cardClasses?: string
    colorizeCards?: boolean
  }>(),
  {
    cardClasses: '',
    colorizeCards: false,
  },
)
</script>
